/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * 失禁
 */
export type FindEmsContactIncontinenceEnum =
  (typeof FindEmsContactIncontinenceEnum)[keyof typeof FindEmsContactIncontinenceEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FindEmsContactIncontinenceEnum = {
  PRESENT_BOTH: 'PRESENT_BOTH',
  PRESENT_FECAL: 'PRESENT_FECAL',
  PRESENT_URINARY: 'PRESENT_URINARY',
  UNKNOWN: 'UNKNOWN',
  NONE: 'NONE',
} as const;
